"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayIndexNode = void 0;
var StringArrayIndexNode;
(function (StringArrayIndexNode) {
    StringArrayIndexNode["StringArrayHexadecimalNumberIndexNode"] = "StringArrayHexadecimalNumberIndexNode";
    StringArrayIndexNode["StringArrayHexadecimalNumericStringIndexNode"] = "StringArrayHexadecimalNumericStringIndexNode";
})(StringArrayIndexNode || (exports.StringArrayIndexNode = StringArrayIndexNode = {}));
